<template>
  <!--  配电室数据监控大屏-->
  <div class="templateBigScreen3">
    <div class="largeScreenContent">
      <!--标题-->
      <div class="screenTitle"></div>
      <!--时间-->
      <div v-show="false" class="timeBoxTemplateBigScreen3">{{ nowTime }}</div>
      <!--天气-->
      <div v-show="false" class="weatherBoxTemplateBigScreen3">晴 25℃ 浙江省杭州市​​东经 120°12′，北纬30°16′​​</div>
      <!--左边数据展示-->
      <div class="leftBoxTemplateBigScreen1">
        <div class="leftItem leftItem1">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/title1.png">
          </div>
          <div class="leftItemCont">
            <div class="listBox">
              <div class="listItem">
                <p class="val">4 <span class="unit">个</span></p>
                <p class="name">配电室</p>
              </div>
              <div class="listItem">
                <p class="val">32 <span class="unit">台</span></p>
                <p class="name">变压器</p>
              </div>
              <div class="listItem">
                <p class="val">1250 <span class="unit">KVA</span></p>
                <p class="name">变压器容量</p>
              </div>
              <div class="listItem">
                <p class="val">14929.23 <span class="unit">KW</span></p>
                <p class="name">月最大负荷</p>
              </div>
              <div class="listItem">
                <p class="val">322 <span class="unit">KW</span></p>
                <p class="name">日最大负荷</p>
              </div>
            </div>
          </div>
        </div>
        <div class="leftItem leftItem2">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/title2.png">
          </div>
          <div class="leftItemCont">
            <div class="circleChartRef chartRef"></div>
          </div>
        </div>
        <div class="leftItem leftItem3">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/title3.png">
          </div>
          <div class="leftItemCont">
            <div class="lineChartRef1 chartRef"></div>
          </div>
        </div>
      </div>
      <!--中间数据展示-->
      <div class="centerBoxTemplateBigScreen1">
        <!--中间上边数据展示-->
        <div class="centerTopBox">
          <div class="centerTopItem">
            <count-up :end-val="totalData.val1" :options="{useGrouping:true}"
                      :start-val="countStart1" class="val">
            </count-up>
            <p class="name">总用电量(kWh)</p>
          </div>
          <div class="centerTopItem">
            <count-up :end-val="totalData.val2" :options="{useGrouping:true}"
                      :start-val="countStart2" class="val">
            </count-up>
            <p class="name">当前总功率(kW)</p>
          </div>
          <div class="centerTopItem">
            <count-up :end-val="totalData.val3" :options="{useGrouping:true}"
                      :start-val="countStart3" class="val">
            </count-up>
            <p class="name">总容量(kW)</p>
          </div>
        </div>
      </div>
      <!--右边数据展示-->
      <div class="rightBoxTemplateBigScreen1">
        <div class="rightItem rightItem1">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/title4.png">
          </div>
          <div class="rightItemCont">
            <img alt="" class="leftIcon"
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/leftArrowIcon.png">
            <el-carousel :autoplay="false" arrow="always" height="100%" trigger="click">
              <el-carousel-item v-for="item in 4" :key="item">
                <p class="tit">A区</p>
                <video src="" style="background: #0a94bd"></video>
              </el-carousel-item>
            </el-carousel>
            <img alt="" class="rightIcon"
                 src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/rightArrowIcon.png">
          </div>
        </div>
        <div class="rightItem rightItem2">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/title5.png">
          </div>
          <div class="rightItemCont">
            <div class="barChartRef chartBox"></div>
          </div>
        </div>
        <div class="rightItem rightItem3">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/title6.png">
          </div>
          <div class="rightItemCont">
            <div class="lineChartRef2 chartBox"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';

// 实时时间**************************************************************************
import {defineProps, nextTick, onMounted, onUnmounted, ref, watch} from "vue";
import moment from "moment";
import * as echarts from "echarts";
import CountUp from "vue-countup-v3";

const props = defineProps(['screenFlag', 'projectModuleId', 'showFlag']);
moment.locale('zh-cn')

let nowTime = ref()
const timer = setInterval(() => {
  nowTime.value = moment().format('YYYY-MM-DD') + '  ' + moment().format('dddd') + '  ' + moment().format('HH:mm:ss')
}, 1000)


// 中上部分累计数据**************************************************************************
let countStart1 = ref(0)
let countStart2 = ref(0)
let countStart3 = ref(0)
let countStart4 = ref(0)
let totalData = ref({
  val1: 12334335423,
  val2: 434345343,
  val3: 1323,
  val4: 50,
})


// 尖峰平谷占比饼图***************************************************************************
const circleChartLoad = function () {
  var chartDom = document.querySelector('.circleChartRef');
  var myChart = echarts.init(chartDom);
  let option = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      show: false
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          // borderRadius: 10,
          // borderColor: 'transparent',
          // borderColor: 'rgba(47,109,255,0)',
          borderWidth: 6
        },
        label: {
          normal: {
            show: true,
            // formatter: '{b}: {d}%'
            formatter: `{a|{b}}{b|{d}%}\n{c|{c}KW}`,
            rich: {
              a: {
                fontSize: 14,
                color: '#fff',
                fontWeight: 700,
                verticalAlign: 'bottom',
                width: 20,
                align: 'center',
              },
              b: {
                fontSize: 14,
                fontWeight: 500,
                color: '#2F6DFF'
              },
              c: {
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(255,255,255,0.6)',
                lineHeight: 30,
              }
            }
          }
        },
        data: [
          {value: 1048, name: '尖'},
          {value: 735, name: '峰'},
          {value: 580, name: '平'},
          {value: 484, name: '谷'}
        ]
      }
    ]
  };
  myChart.clear()
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: 'cubicInOut',
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  }
}


// 有功功率折线图***************************************************************************
const lineChartLoad1 = function () {
  var chartDom = document.querySelector('.lineChartRef1');
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: '单位：kwh',
      textStyle: {
        fontSize: 12,
        fontWeight: 300,
        color: '#fff'
      }
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      show: false
    },
    grid: {
      left: 60,
      top: 30,
      bottom: 30,
      right: 20,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: '#fff'
        }
      },
      data: [1, 2, 3, 4, 5, 6]
    },
    yAxis: {
      type: 'value',
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ['rgba(62, 122, 248, 0.12)'],
        }
      },
      axisLabel: {
        textStyle: {
          color: '#fff'
        }
      },
    },
    series: [
      {
        type: 'line',
        data: [232, 43, 124, 221, 499, 54],
        color: '#3587DA',
        lineStyle: {
          width: 1,
        },
        // showSymbol: false,
        symbolSize: 6,
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, null, 0, 1, [
            {
              offset: 0,
              color: 'rgb(47, 109, 255)'
            },
            {
              offset: 1,
              color: 'rgba(47, 109, 255,0)'
            }
          ])
        }
      }
    ]
  };
  myChart.clear()
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: 'cubicInOut',
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  }
}

// 用电量柱状图***************************************************************************
const barChartLoad = function () {
  var chartDom = document.querySelector('.barChartRef');
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: '单位：kwh',
      textStyle: {
        fontSize: 12,
        fontWeight: 300,
        color: '#fff'
      }
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      show: false
    },
    grid: {
      left: 60,
      top: 30,
      bottom: 30,
      right: 20,
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: '#fff'
        }
      },
      data: [1, 2, 3, 4, 5, 6]
    },
    yAxis: {
      type: 'value',
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ['rgba(62, 122, 248, 0.12)'],
        }
      },
      axisLabel: {
        textStyle: {
          color: '#fff'
        }
      },
    },
    series: [
      {
        type: 'bar',
        data: [232, 43, 124, 221, 499, 54],
        barWidth: 10,
        itemStyle: {
          borderRadius: [10, 10, 0, 0]
        },
        color: new echarts.graphic.LinearGradient(0, null, 0, 1, [
          {
            offset: 0,
            color: 'rgb(47, 109, 255)'
          },
          {
            offset: 1,
            color: 'rgba(47, 109, 255,0)'
          }
        ]),
      }
    ]
  };
  myChart.clear()
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: 'cubicInOut',
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  }
}

// 负荷曲线***************************************************************************
const lineChartLoad2 = function () {
  var chartDom = document.querySelector('.lineChartRef2');
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: '单位：kwh',
      textStyle: {
        fontSize: 12,
        fontWeight: 300,
        color: '#fff'
      }
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      show: true,
      right: 0,
      icon: 'circle',
      textStyle: {
        color: '#fff'
      }
    },
    grid: {
      left: 60,
      top: 30,
      bottom: 30,
      right: 20,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: '#fff'
        }
      },
      data: [1, 2, 3, 4, 5, 6]
    },
    yAxis: {
      type: 'value',
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ['rgba(62, 122, 248, 0.12)'],
        }
      },
      axisLabel: {
        textStyle: {
          color: '#fff'
        }
      },
    },
    series: [
      {
        name: '今日',
        type: 'line',
        data: [232, 43, 124, 221, 499, 54],
        color: '#3587DA',
        lineStyle: {
          width: 1,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, null, 0, 1, [
            {
              offset: 0,
              color: 'rgb(47, 109, 255)'
            },
            {
              offset: 1,
              color: 'rgba(47, 109, 255,0)'
            }
          ])
        }
      }, {
        name: '昨日',
        type: 'line',
        data: [292, 413, 324, 121, 49, 254],
        color: '#0CBCB8',
        lineStyle: {
          width: 1,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, null, 0, 1, [
            {
              offset: 0,
              color: 'rgb(12, 188, 184)'
            },
            {
              offset: 1,
              color: 'rgba(12, 188, 184,0)'
            }
          ])
        }
      }, {
        name: '前日',
        type: 'line',
        data: [132, 143, 224, 421, 299, 154],
        color: '#BCAA0C',
        lineStyle: {
          width: 1,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, null, 0, 1, [
            {
              offset: 0,
              color: 'rgb(188, 170, 12)'
            },
            {
              offset: 1,
              color: 'rgba(188, 170, 12,0)'
            }
          ])
        }
      }
    ]
  };
  myChart.clear()
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: 'cubicInOut',
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  }
}


// 大屏管理***************************************************************************
let screenFlag = ref(false)
// 点击进入全屏
const enterScreenClick = function () {
  // 获取layout的dom元素
  const parentNode = document.querySelector('.templateBigScreen3'); // 获取需要全屏的元素;
  // 进入全屏
  if (parentNode.requestFullscreen) {
    parentNode.requestFullscreen();
  } else if (parentNode.webkitRequestFullScreen) {
    parentNode.webkitRequestFullScreen();
  } else if (parentNode.mozRequestFullScreen) {
    parentNode.mozRequestFullScreen();
  } else if (parentNode.msRequestFullscreen) {
    // IE11
    parentNode.msRequestFullscreen();
  }
  screenFlag.value = true
  nextTick(() => {
    // chartLoad()
  })
}
// 退出全屏
const exitFullscreenClick = () => {
  const parentNode = document.querySelector('.templateBigScreen3'); // 获取需要全屏的元素;
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if ((document).webkitCancelFullScreen) {
    (document).webkitCancelFullScreen();
  } else if ((document).mozCancelFullScreen) {
    (document).mozCancelFullScreen();
  } else if ((document).msExitFullscreen) {
    (document).msExitFullscreen();
  }
  screenFlag.value = false
};
watch(() => props.screenFlag, (newVal) => {
  if (newVal) {
    nextTick(() => {
      enterScreenClick()
    })
  }
}, {immediate: true, deep: true})


// 页面自适应***************************************************************************
const resizeFun = function () {
  nextTick(() => {
    let ele = document.querySelector('.templateBigScreen3')
    let scaleX = (ele.clientWidth) / 1920
    let scaleY = (ele.clientHeight) / 1080
    document.querySelector('.templateBigScreen3 .largeScreenContent').style.transform = `scale(${scaleX},${scaleY})`
  })
}

onMounted(() => {

  nextTick(() => {
    circleChartLoad()
    lineChartLoad1()
    barChartLoad()
    lineChartLoad2()
  })


  resizeFun()
  window.onresize = () => {
    resizeFun()
  }
})

onUnmounted(() => {
  clearInterval(timer)
  // wsService.disconnect();
})


</script>

<style lang="less">
.templateBigScreen3 {
  width: 100%;
  height: 100%;
  color: #fff;

  .largeScreenContent {
    width: 1920px;
    height: 1080px;
    transform-origin: 0% 0%;
    position: relative;
    background: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/background.png") no-repeat 0 0;
    background-size: 100% 100%;

    //标题
    .screenTitle {
      background: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen3/titleBgc.png");
      background-size: 100% 100%;
      position: absolute;
      top: 15px;
      left: 20px;
      width: calc(100% - 40px);
      height: 54px;
      line-height: 54px;
      font-family: Title;
      font-weight: 700;
      font-size: 28px;
      color: #0C4DCC;
      text-align: center;
    }

    //时间
    .timeBoxTemplateBigScreen3 {
      position: absolute;
      top: 24px;
      left: 21px;
      font-size: 16px;
      color: #48637E;
    }

    //操作
    .operatorBox {
      position: absolute;
      left: 20px;
      top: 51px;
      height: 28px;
      display: flex;

      img {
        width: 28px;
        height: 28px;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    //天气
    .weatherBoxTemplateBigScreen3 {
      position: absolute;
      top: 32px;
      right: 38px;
      font-size: 16px;
      color: #48637E;
    }

    //左边数据展示
    .leftBoxTemplateBigScreen1 {
      width: 469px;
      height: 967px;
      position: absolute;
      top: 89px;
      left: 20px;

      .leftItem {
        width: 469px;
        height: 309px;
        margin-bottom: 20px;

        .itemTitle {
          width: 469px;
          height: 29px;
          margin-bottom: 10px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .itemTitleRight {
            position: absolute;
            top: 0;
            right: 20px;
            height: 45px;
            line-height: 45px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }

        .leftItemCont {
          width: 469px;
          height: 254px;
        }
      }

      .leftItem1 {
        .leftItemCont {
          .listBox {
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;

            .listItem {
              width: calc(33.333% - 40px);
              margin-right: 40px;
              text-align: center;
              border: 1px solid;
              border-image: linear-gradient(135deg, rgba(47.0000009983778, 109.00000110268593, 255, 1), rgba(255, 255, 255, 0.5410959124565125), rgba(47.0000009983778, 109.00000110268593, 255, 1)) 1 1;
              line-height: 26px;
              padding: 10px 0;

              p, span {
                color: #fff;
              }

              .val {
                font-size: 16px;
              }

              .name {
                font-size: 12px;
              }
            }

            .listItem:nth-child(3n) {
              margin-right: 0;
            }
          }
        }
      }

      .leftItem2 {
        .leftItemCont {
          .chartRef {
            width: 100%;
            height: 100%;
          }
        }
      }

      .leftItem3 {
        margin-bottom: 0;

        .leftItemCont {
          .chartRef {
            width: 100%;
            height: 100%;
          }
        }

      }
    }


    //中间数据展示
    .centerBoxTemplateBigScreen1 {
      //中上数据
      .centerTopBox {
        width: 800px;
        height: 76px;
        position: absolute;
        left: 560px;
        top: 105px;
        display: flex;
        justify-content: space-between;

        .centerTopItem {
          width: 240px;
          height: 76px;
          border-radius: 4px;
          background: #00071B;
          box-shadow: inset 0px 0px 40px 0px rgba(27, 126, 242, 0.4);
          border: 1px solid #0066FF;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .val {
            font-weight: 700;
            font-size: 24px;
            color: #FFFFFF;
          }

          .name {
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
          }
        }
      }
    }


    //右边数据展示
    .rightBoxTemplateBigScreen1 {
      width: 469px;
      height: 967px;
      position: absolute;
      top: 89px;
      right: 20px;

      .rightItem {
        width: 469px;
        height: 309px;
        margin-bottom: 20px;

        .itemTitle {
          width: 469px;
          height: 29px;
          margin-bottom: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .rightItemCont {
          width: 469px;
          height: 254px;
          position: relative;

          .chartBox {
            width: 100%;
            height: 238px;
            margin-top: 16px;
          }

          .el-carousel {
            height: 100%;

            video {
              width: calc(100% - 88px);
              height: 100%;
              margin-left: 44px;
            }

            .el-carousel__indicators.el-carousel__indicators--horizontal, .el-carousel__arrow {
              display: none;
            }

            .el-carousel__item {
              position: relative;

              .tit {
                position: absolute;
                top: 0;
                left: 44px;
                width: calc(100% - 88px);
                height: 20px;
                background: linear-gradient(90deg, #2F6DFF 0%, rgba(255, 255, 255, 0) 100%);
                line-height: 20px;
                color: #fff;
                font-weight: 700;
                font-size: 12px;
              }
            }

          }

          .leftIcon, .rightIcon {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 24px;
            height: 24px;
          }

          .leftIcon {
            left: 10px;
          }

          .rightIcon {
            right: 10px;
          }
        }
      }

      .rightItem1 {
      }

      .rightItem2 {
      }

      .rightItem3 {
        margin-bottom: 0;
      }
    }


  }

}
</style>
